import React from 'react'
import styled from 'styled-components'

export const RequiredStar = () => {
  return <Star />
}

const Star = styled.span`
  color: ${({ theme }) => theme.colors.error};

  &::after {
    content: '*';
  }
`
